import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Signin from '../pages/SignIn/Singin';
import WatsApp from '../pages/SignIn/Watsapp';
import Dashboard from '../pages/Home';
import NewDashboard from '../pages/Dashboard/main/NewDashboard';
import { Riple } from 'react-loading-indicators';
import ProtectedRoute from '../componant/authentication/ProtectedRoute';

const Mainroute = () => {
  
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
      setLoading(true);
      const timer = setTimeout(() => {
          setLoading(false);
      }, 1000); // Adjust timeout as needed

      return () => clearTimeout(timer);
  }, [location]);
  return (
    <>
     {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
            <Riple color="#FF782D" size="medium" text="" textColor="" />
          </div>
        )}
    <Routes>

        <Route path='/' element={<Signin />}/>
        <Route path='/login' element={<Signin/>}/>
        {/* <Route path='/login-info' element={<WatsApp/>}/> */}
        <Route
          path='/dash/*'
          element={(
            <ProtectedRoute>
              <NewDashboard/>
            </ProtectedRoute>
          )}
        />
        
            {/* <Route path="/login" element={<Navigate to="/" replace />} /> */}
    </Routes>
    </>
  );
};

export default Mainroute;
